import useSWR from 'swr'

//swr
export function useRevvingApi() {
    const url = "https://api.bosotokyo.com/api/revving/fetch";
    const fetcher = async (...args) => {
        try {
            console.log('[useRevvingApi] Fetching data from:', args[0] || url);
            const res = await fetch(...args);
            
            // レスポンスのステータスをチェック
            if (!res.ok) {
                const errorText = await res.text();
                console.error('[useRevvingApi] API Error Response:', {
                    status: res.status,
                    statusText: res.statusText,
                    url: res.url,
                    headers: Object.fromEntries(res.headers.entries()),
                    body: errorText
                });
                const error = new Error(`API Error: ${res.status} ${res.statusText} - ${errorText}`);
                error.status = res.status;
                error.statusText = res.statusText;
                error.responseBody = errorText;
                throw error;
            }
            
            const data = await res.json();
            console.log('[useRevvingApi] Data fetched successfully:', {
                dataLength: Array.isArray(data) ? data.length : 'not an array',
                dataType: typeof data
            });
            return data;
        } catch (error) {
            console.error('[useRevvingApi] Fetcher Error:', {
                message: error.message,
                status: error.status,
                statusText: error.statusText,
                responseBody: error.responseBody,
                stack: error.stack,
                url: args[0] || url,
                errorName: error.name
            });
            throw error;
        }
    };
    const { data, error } = useSWR(url, fetcher)

    // エラーが発生した場合にログを出力
    if (error) {
        console.error('[useRevvingApi] SWR Error:', {
            error: error,
            message: error?.message,
            stack: error?.stack,
            name: error?.name,
            status: error?.status,
            statusText: error?.statusText,
            responseBody: error?.responseBody
        });
    }

    return {
        revvingData: data,
        isLoading: !error && !data,
        isError: error
    }
}


// function Profile() {
//     const fetcher = (...args) => fetch(...args).then(res => res.json())
//     const { data, error } = useSWR('http://ec2-54-242-133-46.compute-1.amazonaws.com/api/revving/fetch', fetcher)

//     if (error) return <div>failed to load</div>
//     if (!data) return <div>loading...</div>

//     return <div>hello {data[0].id}!</div>
// }